import { useEffect, useMemo, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { SortOrder, listFiltersService, ListTableSort } from "sprint-common-web";

export interface SystemListingFilters {
    page: number;
    pageSize: number;
    sortBy: string;
    sortOrder: SortOrder;
}

const defaultFilters: SystemListingFilters = {
    page: 1,
    pageSize: 50,
    sortBy: "name",
    sortOrder: "asc"
};

export const useSystemListingFilters = () => {
    const filtersService = useMemo(() => listFiltersService<SystemListingFilters>(defaultFilters), []);
    const location = useLocation();
    const history = useHistory();

    const [filters, setFilters] = useState<SystemListingFilters>(() => filtersService.getSavedFilters(location.search));

    useEffect(() => {
        filtersService.saveFilters(location.pathname, history, filters);
    }, [location.pathname, history, filters]);

    const setSort = (sort: ListTableSort) => {
        setFilters((prevFilters: SystemListingFilters) => ({
            ...prevFilters,
            sortBy: sort.by,
            sortOrder: sort.order,
            page: 1
        }));
    };

    const setPage = (page: number) => {
        setFilters((prevFilters: SystemListingFilters) => ({ ...prevFilters, page }));
    };

    const setPageSize = (pageSize: number): void => {
        setFilters((prevFilters: SystemListingFilters) => ({ ...prevFilters, pageSize, page: 1 }));
    };

    return {
        filters,
        setPage,
        setPageSize,
        setSort
    };
};
